import styled from 'styled-components';
import { fontS, fontXS, fontL } from 'styles/jakarta';

export const FAQWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.divisions};
  padding: 16px;
`;

export const Question = styled.h2`
  ${fontS}

  max-width: 90%;
  color: ${({ theme }) => theme.content};
`;

export const Answer = styled.p`
  margin-top: 16px;
  ${fontXS};
  max-width: 90%;
  color: ${({ theme }) => theme.content};
  margin-bottom: 16px;

  li {
    line-height: 15.36px;
    ${fontXS};
  }

  p {
    margin-bottom: 16px;
    line-height: 15.36px;
    ${fontXS};
  }

  a {
    ${fontXS};
    color: ${({ theme }) => theme.information.background};
  }

  ol {
    ${fontXS};
    padding-left: 16px;
    list-style: auto;
    margin-bottom: 16px;
  }

  ul {
    ${fontXS};
    padding-left: 16px;
    list-style: auto;
    margin-bottom: 16px;
  }

  img {
    width: 100%;
    margin: 16px 0;
    border-radius: 8px;
  }

  strong {
    ${fontXS};
    font-weight: 700;
  }

  span {
    ${fontXS};
  }

  div {
    ${fontXS};
  }
`;

export const Wrapper = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.background};
`;

export const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  max-width: 600px;
  z-index: 1;
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  background-color: ${({ theme }) => theme.background};
`;

export const Error = styled.div`
  ${fontXS};
  text-align: center;
  padding-top: 37px;
  color: ${({ theme }) => theme.subContent};
`;

export const SectionHeader = styled.h3`
  ${fontL};
  margin: 16px;
`;
